module.exports = __webpack_public_path__ + "static/media/seek_volunteer_logo.ea78b693.svg";